/**
 * Shown on a builder session that was moved to Fias Forge (ADR-023 D6). The
 * session is read-only history from that moment — the server answers 409
 * SESSION_MIGRATED to every mutation — so the banner is the one place that
 * says why the prompt is disabled and where the arche now lives.
 */
import { Hammer, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export const FORGE_ARCHE_ID = 'arche_forge';

export function forgePagePath(forgeId: string): string {
  return `/a/${FORGE_ARCHE_ID}/${forgeId}`;
}

interface ForgeMigratedBannerProps {
  forgeId: string;
}

export function ForgeMigratedBanner({ forgeId }: ForgeMigratedBannerProps) {
  const navigate = useNavigate();
  return (
    <div
      role="status"
      data-testid="forge-migrated-banner"
      className="border-b bg-amber-50 dark:bg-amber-950/20 px-4 py-2 flex items-center gap-2"
    >
      <Hammer className="h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" />
      <span className="flex-1 text-xs text-amber-800 dark:text-amber-200">
        This arche moved to Fias Forge. The builder session is read-only — its files, history and
        publishing now live in the forge.
      </span>
      <Button
        size="sm"
        variant="outline"
        className="h-6 text-xs"
        onClick={() => navigate(forgePagePath(forgeId))}
      >
        Continue in Forge
        <ArrowRight className="h-3 w-3 ml-1" />
      </Button>
    </div>
  );
}
